import { useState, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CheckIcon, CopyIcon } from "../../../assets/icons/audio-icons";

const CustomCopyToClipboard = ({
  displayText,
  copyText,
  displayClassName = "",
  wrapperClassName,
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const onCopy = (e) => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <CopyToClipboard
      text={copyText}
      onCopy={onCopy}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        className={`cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg p-2 inline-flex items-center justify-center w-fit ${wrapperClassName}`}
      >
        <div className={`pr-2 ${displayClassName}`}>{displayText}</div>
        {!isCopied && <CopyIcon />}
        {isCopied && <CheckIcon />}
      </div>
    </CopyToClipboard>
  );
};

export default CustomCopyToClipboard;
